import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
const HBO_ACTIVATION_FLAG_KEY = 'wbd_hbo_max_activation_linkage_enabled';

const toBoolean = value =>
  typeof value === 'string' ? value.toLowerCase() === 'true' : Boolean(value);

// Flag opt-in por region: {"default": false, "<region>": true} (ver TBRFRE-1790 NFRs)
export const useHboActivationFlag = () => {
  const value = useSelector(
    selectMetadataKeyByRegion(HBO_ACTIVATION_FLAG_KEY),
  );
  return value.enabled;
};
